export default {
    computed: {
        deviceLanguages(){
            return ['ces', 'slk', 'deu', 'eng', 'hun'];
        }
    },
    methods: {
        getLanguageNameByCode(code) {
            switch (code) {
                case 'ces':
                    return this.$gettext('Čeština');
                case 'deu':
                    return  this.$gettext('Němčina');
                case 'eng':
                    return  this.$gettext('Angličtina');
                case 'slk':
                case 'slo':
                    return  this.$gettext('Slovenština');
                case 'hun':
                    return  this.$gettext('Maďarština');
                case 'pol':
                    return  this.$gettext('Polština');
                default:
                    return code;
            }
        },
        getIso3FromIso2(iso2Code){
            switch(iso2Code.toLowerCase()){
                case 'cs':
                    return 'ces';
                case 'en':
                    return 'eng';
                case 'de':
                    return 'deu';
                case 'sk':
                    return 'slk';
                case 'hu':
                    return 'hun';
                default:
                    throw new Error('Unknown ISO code');
            }
        },
        getIso2FromIso3(iso3Code) {
            switch(iso3Code.toLowerCase()) {
                case 'ces':
                    return 'cs';
                case 'eng':
                    return 'en';
                case 'deu':
                    return 'de';
                case 'slk':
                    return 'sk';
                case 'hun':
                    return 'hu';
                default:
                    throw new Error('Unknown ISO code');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/languages.js